import { createReducer } from 'redux-create-reducer';

import {
  GET_EMAIL_NOTIFICATIONS,UPDATE_EMAIL_NOTIFICATIONS
} from '../types';

const initialState = {
  data: [],
  isLoading: false,
  failed: false,
};

const getEmailNotificationsReducer = createReducer(initialState, {
  [GET_EMAIL_NOTIFICATIONS.DEFAULT]: state => ({
    ...state,
    isLoading: true,
    failed: false,

  }),
  [GET_EMAIL_NOTIFICATIONS.PENDING]: state => ({
    ...state,
    isLoading: true,
    failed: false,

  }),
  [GET_EMAIL_NOTIFICATIONS.REJECTED]: state => ({
    ...state,
    isLoading: false,
  }),
  [GET_EMAIL_NOTIFICATIONS.FULFILLED]: (state, { payload }) => {
    return ({
      ...state,
      data: payload.data,
      isLoading: false,
    });
  },
  [UPDATE_EMAIL_NOTIFICATIONS.DEFAULT]: state => ({
    ...state,
    isLoading: true,
    failed: false,

  }),
  [UPDATE_EMAIL_NOTIFICATIONS.PENDING]: state => ({
    ...state,
    isLoading: true,
    failed: false,

  }),
  [UPDATE_EMAIL_NOTIFICATIONS.REJECTED]: state => {
    return ({
      ...state,
      isLoading: false,
      failed: true,
    });
  },
  [UPDATE_EMAIL_NOTIFICATIONS.FULFILLED]: (state, { payload }) => {
    var data = [];
    state.data.forEach(element => {
      if(element.id === payload.data.id){
        data.push(payload.data);
      }else{
        data.push(element);
      }
    });
    return ({
      ...state,
      data: data,
      isLoading: false,
      failed: false,
    });
  },
});


export default getEmailNotificationsReducer;


// WEBPACK FOOTER //
// ./src/features/organization/reducers/getEmailNotificationsReducer.js